// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"80":"d612d885","522":"569796b0"}[chunkId] + ".chunk.js");